import View from './View.js';
import previewView from './previewView.js';
import icons from 'url:../../img/icons.svg'; //Parcel 2

class ResultsView extends View {
  _parentElement = document.querySelector('.results');
  _errorMessage = `No recipes found. Please try again!`;
  _message = ``;

  // this._data is all of the results
  _generateMarkup() {
    // needs to return a string
    return this._data
      .map(result => previewView.render(result, false)) //creates an array of strings
      .join(''); // creates one long string that we want to render
  }
}
export default new ResultsView();
